import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { ru } from 'vuetify/locale'
import { resolveInitialTheme } from '@/composables/useAppTheme'

const lightTheme = {
  dark: false,
  colors: {
    primary: '#1976d2',
    secondary: '#424242',
    accent: '#82b1ff',
    error: '#ff5252',
    info: '#2196f3',
    success: '#4caf50',
    warning: '#ffc107',
    background: '#fafafa',
    surface: '#ffffff',
  },
}

// Тёмная тема — свои ступени тех же оттенков, не автоматическая инверсия:
// primary светлее ради контраста на тёмной поверхности, warning/amber без
// изменений (и так читается), поверхности — нейтрально-серые.
const darkTheme = {
  dark: true,
  colors: {
    primary: '#64b5f6',
    secondary: '#b0bec5',
    accent: '#82b1ff',
    error: '#ef5350',
    info: '#42a5f5',
    success: '#66bb6a',
    warning: '#ffca28',
    background: '#15171a',
    surface: '#1e2125',
  },
}

export default createVuetify({
  // Собственные строки Vuetify (футер таблиц «1-25 из 108», «Записей на
  // странице», подписи стрелок) — русские, как и вся админка. Без этого
  // серверный пагинатор истории печатей единственный говорил бы по-английски.
  locale: {
    locale: 'ru',
    messages: { ru },
  },
  theme: {
    // Резолвим до монтирования: сохранённый выбор или prefers-color-scheme,
    // чтобы страница не вспыхивала светлым перед переключением.
    defaultTheme: resolveInitialTheme(),
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
})
